import { CONTROL } from '../../../../components';
import { generateBaseItems, getDisk } from '../../../utils';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var GpuType = /*#__PURE__*/function (GpuType) {
  GpuType["Tesla"] = "GPU NVIDIA\xAE Tesla\xAE V100";
  GpuType["H100"] = "GPU NVIDIA\xAE H100";
  return GpuType;
}(GpuType || {});
var gpuTypeItems = [GpuType.Tesla, GpuType.H100];
var MinAdditionalDiskSize = 15;
var OsType = /*#__PURE__*/function (OsType) {
  OsType["Ubuntu18_04"] = "Ubuntu_18.04";
  OsType["Fedora38"] = "Fedora_38";
  OsType["Debian10"] = "Debian_10";
  OsType["Ubuntu22_04_4"] = "Ubuntu_22.04.4";
  OsType["Ubuntu22_04"] = "Ubuntu_22.04";
  OsType["Ubuntu20_04"] = "Ubuntu_20.04";
  OsType["OpenSUSE15_2"] = "openSUSE_15.2";
  OsType["Debian12"] = "Debian_12";
  OsType["CentOS9"] = "CentOS_9";
  OsType["CentOS8"] = "CentOS_8";
  OsType["CentOS7Kernel5_4"] = "CentOS_7_kernel_5.4";
  OsType["CentOS7"] = "CentOS_7";
  OsType["Ubuntu24_04"] = "Ubuntu_24.04";
  return OsType;
}(OsType || {});
var osItems = [OsType.CentOS7, OsType.CentOS7Kernel5_4, OsType.CentOS8, OsType.CentOS9, OsType.Debian10, OsType.Debian12, OsType.Fedora38, OsType.Ubuntu22_04, OsType.Ubuntu22_04_4, OsType.Ubuntu20_04, OsType.Ubuntu18_04, OsType.Ubuntu24_04, OsType.OpenSUSE15_2];
var CardValuesTesla = {
  GPU1_vCPU4_RAM64: "1 4 64",
  GPU2_vCPU8_RAM128: "2 8 128",
  GPU4_vCPU16_RAM256: "4 16 256",
  GPU8_vCPU32_RAM512: "8 32 512",
  GPU16_vCPU64_RAM1024: "16 64 1024"
};
var CardValuesH100 = {
  GPU1_vCPU20_RAM185: "1 20 186",
  GPU2_vCPU40_RAM372: "2 40 372",
  GPU3_vCPU60_RAM558: "3 60 558",
  GPU4_vCPU80_RAM744: "4 80 744",
  GPU5_vCPU100_RAM930: "5 100 930",
  GPU6_vCPU120_RAM1116: "6 120 1116",
  GPU7_vCPU140_RAM1302: "7 140 1302",
  GPU8_vCPU160_RAM1488: "8 160 1488"
};
var getParamsByConfigTypeCard = function getParamsByConfigTypeCard(value) {
  var _value$split = value.split(' '),
    gpuCount = _value$split[0],
    vCpuCoreCount = _value$split[1],
    ramAmount = _value$split[2];
  return {
    gpuCount: gpuCount,
    vCpuCoreCount: vCpuCoreCount,
    ramAmount: ramAmount
  };
};
var generateCards = function generateCards(cardsData, gpuType) {
  return Object.keys(cardsData).map(function (cardDataKey) {
    var _getParamsByConfigTyp = getParamsByConfigTypeCard(cardsData[cardDataKey]),
      gpuCount = _getParamsByConfigTyp.gpuCount,
      vCpuCoreCount = _getParamsByConfigTyp.vCpuCoreCount,
      ramAmount = _getParamsByConfigTyp.ramAmount;
    return {
      value: cardsData[cardDataKey],
      label: gpuType,
      description: /*#__PURE__*/_jsxs(_Fragment, {
        children: [gpuCount, " GPU ", /*#__PURE__*/_jsx("br", {}), vCpuCoreCount, " vCPU ", /*#__PURE__*/_jsx("br", {}), ramAmount, " \u0413\u0411 RAM"]
      })
    };
  });
};
var getMinOsDiskSpace = function getMinOsDiskSpace(os) {
  var minSize5GbOs = [OsType.Fedora38, OsType.Ubuntu18_04, OsType.Debian10];
  var minSize15GbOs = [OsType.Ubuntu24_04];
  var minSizeByOsMap = {
    5: minSize5GbOs,
    15: minSize15GbOs
  };
  var osMinDiskSizeEntry = Object.entries(minSizeByOsMap).find(function (osMinDiskSizeEntries) {
    var osMap = osMinDiskSizeEntries[1];
    if (osMap.includes(os)) {
      return true;
    }
  });
  if (!osMinDiskSizeEntry) return 10;
  return Number(osMinDiskSizeEntry[0]);
};
export var EVOLUTION_CLOUD_SERVER_GPU_FORM_CONFIG = {
  ui: [['osType'], ['gpuType'], 'configTypeCard', ['systemDisk'], 'additionalOptions', 'networkIsNeeded'],
  controls: {
    osType: {
      type: CONTROL.SelectSingle,
      accessorKey: 'os',
      defaultValue: OsType.Ubuntu22_04,
      items: generateBaseItems(osItems, function (value) {
        return value.replace(/_/g, ' ');
      }),
      decoratorProps: {
        label: 'Операционная система'
      },
      onChangeFn: function onChangeFn(value, setValue) {
        var arr = [['os', value], ['evs.systemDisk.diskSpace', getMinOsDiskSpace(value)]];
        setValue(arr);
      }
    },
    gpuType: {
      type: CONTROL.SelectSingle,
      accessorKey: 'gpuType',
      defaultValue: GpuType.Tesla,
      items: generateBaseItems(gpuTypeItems),
      decoratorProps: {
        label: 'Тип графического процессора'
      },
      uiProps: {
        visible: false
      }
    },
    // значение не учитывается при подсчете data
    configTypeCard: {
      type: CONTROL.ToggleCards,
      accessorKey: 'configTypeCard',
      defaultValue: CardValuesTesla.GPU1_vCPU4_RAM64,
      items: generateCards(CardValuesTesla, GpuType.Tesla),
      decoratorProps: {
        label: 'Конфигурация'
      },
      watchedControls: {
        gpuType: 'gpuType'
      },
      onChangeFn: function onChangeFn(value, setValue) {
        var _getParamsByConfigTyp2 = getParamsByConfigTypeCard(value),
          gpuCount = _getParamsByConfigTyp2.gpuCount,
          vCpuCoreCount = _getParamsByConfigTyp2.vCpuCoreCount,
          ramAmount = _getParamsByConfigTyp2.ramAmount;
        var valuesToSet = [['configTypeCard', value], ['gpuCount', gpuCount], ['vCpuCoreCount', vCpuCoreCount], ['ramAmount', ramAmount]];
        setValue(valuesToSet);
      },
      relateFn: function relateFn(_ref) {
        var gpuType = _ref.gpuType;
        return {
          items: gpuType === GpuType.H100 ? generateCards(CardValuesH100, GpuType.H100) : generateCards(CardValuesTesla, GpuType.Tesla)
        };
      }
    },
    gpuCount: {
      type: CONTROL.Segmented,
      accessorKey: 'gpuCount',
      defaultValue: '1',
      items: [],
      decoratorProps: {
        label: ''
      },
      uiProps: {
        visible: false
      }
    },
    vCpuCoreCount: {
      type: CONTROL.Segmented,
      accessorKey: 'vCpuCoreCount',
      defaultValue: '4',
      items: [],
      decoratorProps: {
        label: ''
      },
      uiProps: {
        visible: false
      }
    },
    ramAmount: {
      type: CONTROL.Segmented,
      accessorKey: 'ramAmount',
      defaultValue: '64',
      items: [],
      decoratorProps: {
        label: ''
      },
      uiProps: {
        visible: false
      }
    },
    systemDisk: getDisk({
      space: {
        label: 'Диск',
        accessorKey: 'evs.systemDisk.diskSpace',
        defaultValue: 10,
        uiProps: {
          min: 10,
          max: 4096
        },
        watchedControls: {
          os: 'os'
        },
        relateFn: function relateFn(_ref2) {
          var os = _ref2.os;
          return {
            uiProps: {
              min: getMinOsDiskSpace(os)
            }
          };
        }
      },
      specification: {
        accessorKey: 'evs.systemDisk.specification',
        defaultValue: 'SSD',
        uiProps: {
          disabled: true
        }
      }
    }),
    additionalOptions: {
      type: CONTROL.Object,
      ui: ['alertAdditional', ['additionalDisks']],
      controls: {
        alertAdditional: {
          type: 'alert',
          uiProps: {
            appearance: 'info',
            outline: true,
            description: 'Можно добавить до 7 дополнительных дисков'
          },
          accessorKey: 'addDisk'
        },
        additionalDisks: {
          type: CONTROL.Array,
          max: 7,
          accessorKey: 'evs.additionalDisks',
          addText: 'Добавить диск',
          ui: ['disk'],
          defaultValue: [],
          controls: {
            disk: getDisk({
              space: {
                label: 'Дополнительный диск',
                accessorKey: 'diskSpace',
                defaultValue: MinAdditionalDiskSize,
                // TODO в текущем исполнении watchedControls и relateFn работают не корректно, поэтому в дальнейшем будут внесены правки, чтобы правильно отображать минимальные значения дисков
                uiProps: {
                  min: MinAdditionalDiskSize,
                  max: 4096
                }
              },
              specification: {
                accessorKey: 'specification',
                defaultValue: 'SSD',
                uiProps: {
                  disabled: true
                }
              }
            })
          }
        }
      }
    },
    networkIsNeeded: {
      type: CONTROL.Toggle,
      defaultValue: false,
      accessorKey: 'networkIsNeeded',
      decoratorProps: {
        label: 'Аренда публичного IP'
      }
    },
    network: {
      type: CONTROL.Object,
      defaultValue: {
        ipQuantity: 1,
        bindingIpAddressesQuantity: 0,
        publicGatewayQuantity: 0,
        privateGatewayQuantity: 0
      },
      ui: [],
      controls: {},
      visible: false
    }
  }
};